<!--
 * @Author: your name
 * @Date: 2021-04-14 15:15:53
 * @LastEditTime: 2021-09-07 09:14:04
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \topboomadmin\src\views\auction\Detail.vue
-->
<template>
  <div style="padding-bottom: 68px;">
    <div class="item">
      <div class="head">拍卖信息</div>
      <div class="sale-content">
        <div class="">标题：</div>
        <el-col :span="6">
          <el-input placeholder="请输入标题"
                    v-model="detail.title">
          </el-input>
        </el-col>
      </div>
      <div class="sale-content"
           v-if="this.recordPage.total > 0">
        <div class="sale-info-item">当前价格：￥{{this.detail.max_amount/100}}</div>
        <div class="sale-info-item">出价次数：{{this.recordList.length}}
          <span class="edit"
                @click="showRecordDlg">查看</span>
        </div>
        <div class="sale-info-item">成交价：￥{{this.detail.max_amount/100}}</div>
      </div>
    </div>

    <div class="item">
      <div class="head">拍卖时间设置</div>
      <div class="item-content">
        <el-form inline>
          <el-form-item label="拍卖时间">
            <el-date-picker v-model="detail.date"
                            type="datetimerange"
                            format="yyyy-MM-dd HH:mm:ss"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="选择日期时间" />
          </el-form-item>
        </el-form>
      </div>
    </div>

    <div class="item">
      <div class="head">拍卖商品设置</div>
      <div class="item-content">
        <span class="title">关联商品</span>
        <span class="tips"
              style="margin-top:8px">提示：关联商品在活动期间不得下架，否则活动将会中途失效</span>
        <el-button class="tb-button add"
                   type="primary"
                   @click="add">
          <i class="tb-icon-plus" />关联商品
        </el-button>
        <div class="tablebox"
             style="width:50%">
          <el-table class="tb-table"
                    :data="productList">
            <el-table-column prop="product_name"
                             label="关联商品名称"
                             show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="prop"
                             label="操作">
              <template slot-scope="scope">
                <span class="edit"
                      @click="removeProduct(scope.row)">删除</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="width:50%;margin-top:16px">
          <el-form label-width="100px">
            <el-form-item label="起拍价：">
              <div>
                <el-input v-model="detail.auction_limit"></el-input>
                <div class="tips">
                  <i class="el-icon-info" />
                  注：起拍价不得大于商品原价
                </div>
              </div>
            </el-form-item>
            <el-form-item label="加价幅度：">
              <div>
                <el-input v-model="detail.auction_step"></el-input>
                <div class="tips">
                  <i class="el-icon-info" />
                  注：每次竞拍的加价金额
                </div>
              </div>
            </el-form-item>
            <el-form-item label="保证金：">
              <div>
                <el-input v-model="detail.auction_deposit"></el-input>
                <div class="tips">
                  <i class="el-icon-info" />
                  注：保证金建议不得大于¥10元，防止竞拍成功用户不支付尾款
                </div>
              </div>
            </el-form-item>
            <el-form-item label="一口价：">
              <div>
                <el-input v-model="detail.max_price"></el-input>
                <div class="tips">
                  <i class="el-icon-info" />
                  注：一口价，为0则表示不设置
                </div>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <el-divider></el-divider>
        <div class="item-status">
          <span class="status-title">活动状态</span>
          <el-radio-group v-model="detail.status">
            <el-radio :label="1">上架</el-radio>
            <el-radio :label="0">下架</el-radio>
          </el-radio-group>
          <div class="tips"
               style="margin-top:8px">
            <i class="el-icon-info" />
            注：保证金建议不得大于¥10元，防止竞拍成功用户不支付尾款
          </div>
        </div>
        <div class="item-status m-t-8">
          <span class="status-title">是否VIP参与</span>
          <el-radio-group v-model="detail.is_vip">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
          <div class="tips"
               style="margin-top:8px">
            <i class="el-icon-info" />
            注：是否仅允许VIP参与
          </div>
        </div>
      </div>
    </div>
    <div class="fix-confirm">
      <el-button class="tb-button"
                 @click="cancel">取消</el-button>
      <el-button class="tb-button"
                 type="primary"
                 @click="submit">发布</el-button>
    </div>

    <el-dialog title="选择商品"
               width="50vw"
               :visible.sync="productDialog">

      <el-dialog title="选择SKU"
                 :visible.sync="skuDialog"
                 append-to-body>
        <el-select v-model="selectSku"
                   placeholder="请选择SKU">
          <el-option :label="sku.attribute_name_one + (sku.attribute_name_two ? sku.attribute_name_two : '')"
                     :value="sku.sku_id"
                     v-for="(sku,index) in sku_list"
                     :key="index">
          </el-option>
        </el-select>
        <span slot="footer">
          <el-button type="primary"
                     @click="onConfrimSku">确定</el-button>
          <el-button @click="skuDialog = false">取 消</el-button>
        </span>
      </el-dialog>
      <div class="product-search flex">
        <span>搜索商品：</span>
        <el-input v-model="productname"
                  style="width: 216px;"
                  @change="searchGoods"></el-input>
      </div>
      <el-table ref="multipleTable"
                :data="productData"
                class="tb-table"
                height="48vh"
                highlight-current-row
                @current-change="handleCurrentChange">
        <el-table-column type="index"
                         width="80" />
        <el-table-column prop="product_id"
                         label="商品id"
                         width="100" />
        <el-table-column prop="product_name"
                         label="商品名称" />
      </el-table>
      <el-pagination background
                     class="tb-pagination"
                     layout="prev, pager, next"
                     :current-page="page.no + 1"
                     :page-size="page.size"
                     :total="page.total"
                     @current-change="pageChange" />
      <span slot="footer">
        <el-button @click="productDialog = false">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog title="出价记录"
               :visible.sync="isRecordDlg"
               width="30vw">
      <el-table :data="recordList"
                class="tb-table"
                height="60vh">
        <el-table-column prop="nick_name"
                         label="昵称"
                         width="100" />
        <el-table-column prop="amount"
                         label="出价">
          <template slot-scope="scope">
            {{scope.row.amount/100}}
          </template>
        </el-table-column>
        <el-table-column prop="created_at"
                         label="时间" />
      </el-table>
      <el-pagination background
                     class="tb-pagination"
                     layout="prev, pager, next"
                     :current-page="recordPage.no + 1"
                     :page-size="recordPage.size"
                     :total="recordPage.total"
                     @current-change="recordPageChange" />
      <span slot="footer">
        <el-button @click="productDialog = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>

</template>

<script>
export default {
  data () {
    return {
      recordList: [],
      isRecordDlg: false,
      productDialog: false,
      skuDialog: false,
      productname: '',
      productData: [],
      productChoose: [],
      sku_list: [],
      selectSku: null,
      page: {
        no: 0,
        size: 10,
        total: 0
      },
      recordPage: {
        no: 0,
        size: 10,
        total: 0
      },
      detail: {
        title: '',
        date: [],
        productName: ''
      }
    }
  },
  mounted () {
    if (this.$route.query.id) {
      this.getDetail()
    }
  },
  computed: {
    productList () {
      if (this.detail.productName) {
        return [{ product_name: this.detail.productName }]
      } else {
        return []
      }
    }
  },
  methods: {
    removeProduct () {
      this.$confirm('是否删除此商品?', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.detail.product_id = null
        this.detail.sku_id = null
        this.detail.productName = null
      }).catch(() => { })
    },
    async getDetail () {
      const params = { id: this.$route.query.id }
      const url = 'admin/auction/detail'
      const detail = await this.$https.get(url, { params })
      detail.date = [detail.start_time, detail.end_time]
      detail.auction_limit = detail.auction_limit / 100
      detail.auction_deposit = detail.auction_deposit / 100
      detail.auction_step = detail.auction_step / 100
      detail.max_price = detail.max_price / 100
      this.detail = detail
      this.getRecordList()
    },
    onConfrimSku () {
      if (!this.selectSku) {
        this.$message.error('请选择SKU')
        return
      }
      this.detail.sku_id = this.selectSku
      this.detail.product_id = this.productChoose[0].product_id
      this.detail.productName = this.productChoose[0].product_name
      this.skuDialog = false
      this.productDialog = false
    },
    searchGoods () {
      this.page.no = 0
      this.getProduct()
    },
    async handleCurrentChange (val) {
      this.productChoose = [val]
      const params = { id: val.product_id }
      const url = 'admin/product/detail'
      const detail = await this.$https.get(url, { params })
      if (!detail) return
      this.sku_list = detail.sku_list
      this.selectSku = null
      this.skuDialog = true
    },
    pageChange (no) {
      this.page.no = no - 1
      this.getProduct()
    },
    showRecordDlg () {
      this.isRecordDlg = true
      this.getRecordList()
    },
    getRecordList () {
      const { no, size } = this.recordPage
      const params = {
        page_no: no,
        page_size: size,
        id: this.detail.id
      }
      const url = 'admin/auction/record/list'
      this.$https.get(url, { params }).then(res => {
        if (!res) return
        this.recordPage.total = res.total_count
        this.recordList = res.list
      })
    },
    recordPageChange (no) {
      this.recordPage.no = no - 1
      this.getRecordList()
    },
    getProduct () {
      const { no, size } = this.page
      const params = {
        page_no: no,
        page_size: size,
        name: this.productname
      }
      const url = 'admin/theme/product/add/list'
      this.$https.get(url, { params }).then(res => {
        if (!res) return
        this.page.total = res.total_count
        this.productData = res.list
      })
    },
    add () {
      this.productDialog = true
      this.skuDialog = false
      this.page.no = 0
      this.getProduct()
    },
    cancel () {
      this.$router.go(-1)
    },
    submit () {
      if (!this.detail.title) {
        this.$message.error('请输入标题')
        return
      }
      if (!this.detail.date || this.detail.date.length === 0) {
        this.$message.error('请选择时间')
        return
      }
      if (!this.detail.sku_id) {
        this.$message.error('请选择商品')
        return
      }
      if (!this.detail.auction_limit) {
        this.$message.error('请输入起拍价')
        return
      }
      if (!this.detail.auction_step) {
        this.$message.error('请输入加价幅度')
        return
      }
      if (!this.detail.auction_deposit) {
        this.$message.error('请输入保证金')
        return
      }
      // if (!this.detail.status) {
      //   this.$message.error('请选择活动状态')
      //   return
      // }
      const params = {
        title: this.detail.title,
        start_time: this.detail.date[0],
        end_time: this.detail.date[1],
        auction_limit: this.detail.auction_limit * 100,
        auction_step: this.detail.auction_step * 100,
        auction_deposit: this.detail.auction_deposit * 100,
        max_price: this.detail.max_price * 100,
        status: this.detail.status,
        is_vip: this.detail.is_vip,
        product_id: this.detail.product_id,
        sku_id: this.detail.sku_id
      }
      if (this.detail.id) {
        params.id = this.detail.id
      }
      const url = 'admin/auction/edit'
      this.$https.post(url, params).then(res => {
        if (res) {
          this.$message.success('编辑成功')
          this.$router.go(-1)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.item {
  margin: 24px 24px 0;
  background-color: #fff;

  .sale-content {
    display: flex;
    align-items: center;
    padding: 16px 32px;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85);
    font-size: 14px;
    .sale-info-item {
      flex: 1 0 auto;
      .edit {
        color: #1890ff;
        margin-left: 2px;
      }
    }
  }

  .tips {
    font-size: 14px;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.45);
    display: block;
  }
  .head {
    padding: 16px 32px;
    font-size: 16px;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.85);
    border-bottom: 1px solid #e9e9e9;
    box-sizing: border-box;
  }
  .item-content {
    padding: 16px 32px;
    .title {
      font-size: 16px;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.85);
      display: block;
    }

    .add {
      margin-top: 24px;
    }
    .m-t-8 {
      margin-top: 8px;
    }
    .item-status {
      .status-title {
        font-size: 14px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.85);
        display: block;
        margin-bottom: 8px;
      }
    }
  }
}
</style>